import callApi from '../../util/apiCaller';

// Export Constants
export const FETCH_ALL_FILTERS = 'FETCH_ALL_FILTERS';
export const DELETE_FILTER = 'DELETE_FILTER';
export const FETCH_FILTER = 'FETCH_FILTER';
export const UPDATE_FILTER = 'UPDATE_FILTER';
export const ADD_FILTER = 'ADD_FILTER';
export const ADD_FILTER_MAPPING = 'ADD_FILTER_MAPPING';
export const UPDATE_FILTER_MAPPING = 'UPDATE_FILTER_MAPPING';
export const DELETE_FILTER_MAPPING = 'DELETE_FILTER_MAPPING';
export const UPDATE_FILTER_MAPPING_VALUES = 'UPDATE_FILTER_MAPPING_VALUES';
export const UNMAP_MAPPING_VALUES = 'UNMAP_MAPPING_VALUES';
export const RESET_IS_NEW_FILTER_MAPPING = 'RESET_IS_NEW_FILTER_MAPPING';
export const FETCH_FILTER_OPTIONS = 'FETCH_FILTER_OPTIONS';
// Export Actions
export function fetchAllFilters() {
  return (dispatch) => {
    dispatch({
      type: FETCH_ALL_FILTERS, filters: [], meta: [], status: 'loading', errors: null,
    });
    const p1 = callApi('filters', 'GET');
    const p2 = callApi('filters/meta', 'GET');
    const p = new Promise((resolve, reject) => {
      Promise.all([p1, p2]).then(
        ([res1, res2]) => {
          resolve({
            filters: res1.filters,
            meta: res2.meta,
            status: 'loaded',
            errors: null,
          });
        },
        (errors) => {
          reject(errors);
        },
      );
    });
    p.then(
      (results) => {
        dispatch({ type: FETCH_ALL_FILTERS, ...results });
      },
      (errors) => {
        dispatch({
          type: FETCH_ALL_FILTERS, filters: [], meta: [], status: 'error', errors,
        });
      },
    );
    return p;
  };
}

export function deleteFilter(id) {
  return dispatch => callApi(`filters/${id}`, 'DELETE').then(() => {
    dispatch({ type: DELETE_FILTER, id });
  });
}

export function updateFilter(params) {
  return dispatch => callApi(`filters/${params._id}`, 'PUT', params).then(res => dispatch({ type: UPDATE_FILTER, ...res }));
}

export function addFilter(params) {
  return dispatch => callApi('filters', 'POST', params).then(res => dispatch({ type: ADD_FILTER, ...res }));
}

export function fetchFilter(id) {
  return dispatch => callApi(`filters/${id}`, 'GET').then((res) => {
    return dispatch({ type: FETCH_FILTER, ...res });
  });
}

export function fetchFilterOptions(id, params = {}) {
  return dispatch => callApi(`filters/${id}/options`, 'GET', params).then((res) => {
    return dispatch({ type: FETCH_FILTER_OPTIONS, id, ...res, query: params.q || null });
  });
}


export function addFilterMapping(filterId, params) {
  return dispatch => callApi(`filters/${filterId}/mappings`, 'POST', params).then((res) => {
    if (res.mapping) {
      res.mapping.is_new = true;
    }
    return dispatch({ type: ADD_FILTER_MAPPING, ...res, filterId });
  });
}

export function resetIsNewFilterMapping(filterId, mappingIds) {
  return (dispatch) => {
    dispatch({ type: RESET_IS_NEW_FILTER_MAPPING, filterId, mappingIds });
  };
}

export function updateFilterMapping(filterId, params) {
  return dispatch => callApi(`filters/${filterId}/mappings/${params._id}`, 'PUT', params).then((res) => {
    return dispatch({ type: UPDATE_FILTER_MAPPING, ...res, filterId });
  });
}

export function deleteFilterMapping(filterId, id) {
  return dispatch => callApi(`filters/${filterId}/mappings/${id}`, 'DELETE').then(() => {
    dispatch({ type: DELETE_FILTER_MAPPING, filterId, id });
  });
}


export function updateMappingValues(filterId, id, params, append = false) {
  return (dispatch) => {
    const p = callApi(`filters/${filterId}/mappings/${id}/values?${append ? 'append=true' : ''}`, 'PUT', params)
    p.then(
      (res) => {
        dispatch({
          type: UPDATE_FILTER_MAPPING_VALUES, filterId, id, ...res,
        });
      },
    );
    return p;
  };
}


export function upmapMappingValues(filterId, params) {
  return dispatch => callApi(`filters/${filterId}/mappings`, 'DELETE', params).then((res) => {
    dispatch({ type: UNMAP_MAPPING_VALUES, filterId, ...res });
  });
}
